import { createContext, useContext } from 'react';
import { ReportReaderLocation, TrackEvent } from './types';
import { getTrackingFunctionsForContext } from './utils';
import { noop } from 'lodash';

export const ReportTrackingContext = createContext<{
  trackEvent: TrackEvent;
  reportReaderLocation: ReportReaderLocation;
} | null>(null);

export const useReportTracking = () => {
  const contextValue = useContext(ReportTrackingContext);
  if (!contextValue)
    // We don't need this tracking if i.e. looking at the search results preview
    return {
      trackSorting: noop,
      trackFiltering: noop,
      trackOpenComponentInWorkspace: noop,
      trackOpenComponentOverviewPage: noop,
      trackMissingReadAccess: noop,
    } as ReturnType<typeof getTrackingFunctionsForContext>;
  const { trackEvent, reportReaderLocation } = contextValue;
  return getTrackingFunctionsForContext(trackEvent, reportReaderLocation);
};
